export const gitVersion = {
  "commit": "48b820a",
  "commitLong": "48b820a2a0e60dc2dc97a7db204ad72776e208fc",
  "branch": "v1.1.1",
  "version": "1.1.1",
  "date": "2020-10-30T16:17:51.000Z",
  "count": 490
}